import React from 'react';
import { useQuery,  Loading, Error,Link  } from 'react-admin';
import Iframe from '../../controls/Iframe'
import Button from '@material-ui/core/Button';


const FilePull = ({ props }) => {
   const downloadUrl = process.env.REACT_APP_LAB_DOWNLOAD_URL;
   var name = (props&& props.location)? props.location.name: null;
   var option = (props&& props.location)? props.location.option: null;
   var brcode = (props&& props.location)? props.location.brcode: null;

   var fid = brcode + '~' + option + '~' + name;
    var source = downloadUrl +'/' + fid
   
    //console.log('FilePull - Source:' + source)
    return (
        <div >
           <Iframe  source={source}   />
           <a href={source} target="_blank" rel="noopener noreferrer" download>
            <Button>
                <i className="fas fa-download"/>
                Download File
            </Button>
            </a>
            
        </div>
    );
};

export default FilePull;